import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cigna-datatable-action-links',
  templateUrl: './datatable-action-links.component.html',
  styleUrls: ['./datatable-action-links.component.scss'],
})
export class DatatableActionLinksComponent {
  @Input() actions: TableActionLink[];
  @Input() selectedAction: string;
  @Input() actionHeader: string;
  @Output() actionChange = new EventEmitter();
}

export interface TableActionLink {
  label: string;
  value: string;
}
